import type { AxiosInstance } from "axios";
import type {
  ApiConfig,
  CustomAxiosRequestConfig,
  RefreshTokenResult,
  WhitelistConfig,
} from "./types";

/** 刷新 Token、获取用户信息的默认接口配置 */
export const apiConfig: ApiConfig = {
  refreshToken: { method: "POST", path: "/api/auth/refresh" },
  getUserInfo: { method: "GET", path: "/api/user/current" },
};

/** 请求层内置白名单，与项目传入白名单合并后生效 */
export const layerWhitelist: Required<WhitelistConfig> = {
  noTokenPaths: [
    "/api/login",
    "/api/captcha",
    "/api/register",
    apiConfig.refreshToken.path,
  ],
  skipRefreshPaths: [apiConfig.refreshToken.path, "/api/login"],
};

/** 调用刷新 Token 接口，需传入当前 axios 实例 */
export function requestRefresh(
  instance: AxiosInstance,
  refreshToken: string,
  config: ApiConfig = apiConfig,
): Promise<RefreshTokenResult> {
  const params = {
    grantType: "refresh_token",
    refreshToken,
    clientAuthn: "",
  };

  return instance
    .request<RefreshTokenResult>({
      method: config.refreshToken.method,
      url: config.refreshToken.path,
      data: params,
      skipTokenRefresh: true,
    } as CustomAxiosRequestConfig)
    .then((res) => res.data);
}

/** 调用获取用户信息接口，需传入当前 axios 实例 */
export function requestUserInfo(
  instance: AxiosInstance,
  config: ApiConfig = apiConfig,
): Promise<unknown> {
  return instance.request({
    method: config.getUserInfo.method,
    url: config.getUserInfo.path,
    data: {},
  });
}
